import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DashboardtemplateService as ApiTemplateDashboardService } from '../../../../api-main/api/dashboardtemplate.service';
import { ConfigService } from '../../../shared/services/config.service';
import { DashboardTemplateSaveDto, ListFilterRequestDto } from '../../../../api-main';

@Injectable({
  providedIn: 'root',
})
export class DashboardTemplateApiService {
  private http = inject(HttpClient);
  private apiDashboardTemplateService = inject(ApiTemplateDashboardService);

  constructor() {
    this.apiDashboardTemplateService = new ApiTemplateDashboardService(
      this.http,
      ConfigService.getApiConfig(),
      undefined,
    );
  }

  get(id: number) {
    return this.apiDashboardTemplateService.dashboardTemplateControllerGet(id);
  }

  save(dashboard: DashboardTemplateSaveDto) {
    return this.apiDashboardTemplateService.dashboardTemplateControllerSave(dashboard);
  }

  list(filter: ListFilterRequestDto = null) {
    if (filter == null)
      filter = {
        page_index: 0,
        page_size: 100,
        sort_direction: 'asc',
      };
    return this.apiDashboardTemplateService.dashboardTemplateControllerList(filter);
  }

  delete(id: number) {
    return this.apiDashboardTemplateService.dashboardTemplateControllerDelete(id);
  }
}
